export const isProd = window.location.host === 'submaran.datamaran.com'
export function isValidUrl(string) {
	try {
		new URL(string)
		return true
	} catch {
		console.error('Invalid URL')
		return false
	}
}
